package it.unibo.tuprolog.solve.stdlib.primitive

import it.unibo.tuprolog.core.Term
import it.unibo.tuprolog.solve.ExecutionContext
import it.unibo.tuprolog.solve.primitive.TypeTester

object Integer : TypeTester<ExecutionContext>("integer") {
    override val help: String =
        """
        `integer(@Term)`
        
        Succeeds if `Term` is an integer; fails otherwise.

        **Examples**

        ```prolog
        ?- integer(42).
        yes.

        ?- integer(4.2).
        no.

        ?- integer(X).
        no.
        ```
        """.trimIndent()

    override fun testType(term: Term): Boolean = term is it.unibo.tuprolog.core.Integer
}
